module.exports = __webpack_public_path__ + "docs/wdrp-1.5.pdf";